import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const migrations:SchemaTableOptions = {
    name:<string> 'migrations',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'name', value: 'VARCHAR(191)' }
    ]
}